module.exports = __webpack_public_path__ + "static/img/2areaB_13.054567f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_13.png
// module id = 1145
// module chunks = 1